import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { DiagnosticOrderActionsService } from '../../services/diagnostic-order-actions.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { IDiagnosticOrder } from '../../interfaces/diagnostic-order.interface';
import {ActivatedRoute} from "@angular/router";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-aberrations-route-wrapper',
  templateUrl: './aberrations-route-wrapper.component.html',
  styleUrls: ['./aberrations-route-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AberrationsRouteWrapperComponent implements OnInit, OnDestroy {

  private destroyed$ = new Subject();

  revisionId: string;
  currentOrder$: Observable<IDiagnosticOrder>;

  constructor(private routerManagerService: RouterManagerService, private diagnosticOrderActionsService: DiagnosticOrderActionsService) { }

  ngOnInit() {
    this.revisionId = this.routerManagerService.parameters?.revisionId;

    this.currentOrder$ = this.diagnosticOrderActionsService.getState()
      .takeUntil(this.destroyed$.asObservable())
      .filter(state => !!state.order && Object.keys(state.order).length > 0)
      .map(state => state.order);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

}
